<template>
  <div>
      <!-- 头部 -->
      <top></top>
      <div class="container">
        <!-- 嘉宾寄语 -->
        <div class="guestvideo">
        </div>
        <div class="guestinfor">
          <div class="left">
          </div>
          <div class="right">
            <div class="guestmain">
              <p class="title">姓氏名</p>
              <p>中国家纺协会</p>
              <p>会长</p>
            </div>
            <div class="guestcon"> 
              <p>2020年突如其来的疫情让我们错过了春季展会，但随着国家及社会各个部门的众志成城，让我们的秋季展顺利如期而至，在此我表示由衷的感谢，并预祝大会顺利召开！</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <bottom v-if="famousList.length > 3"></bottom>
      <bottom v-else style="position:fixed;bottom:0;"></bottom>
  </div>
</template>

<script>
import top from "../../../components/top.vue";
import bottom from "../../../components/bottom.vue";
import { getFamousDetail} from "@/api/api";
export default {
  components: { top, bottom},
  name: "home",
  data() {
    return {
      famousList: [],
    }
  },
  created() {
  },
  mounted() {
    this.id = this.$route.query.detailsId;
    console.log(this.id)
    this.getDetail();
  },
  methods: {//嘉宾寄语
    getDetail(){
      let data = {
        id: this.id
      }
      getFamousDetail(data).then(res=>{
        console.log(res.data)
        if(res.data.errno == 0){
          //this.famousList = res.data.rst;
        }
      }).catch(err=>{
        console.log(err)
      })
    },
  }
}
</script>

<style>
.guestvideo{height: 434px;background: red;margin: 37px 0 22px;}
.guestinfor{display: flex;}
.guestinfor .left{width:100px;height:100px;background: red;border-radius: 100%;margin-right: 16px;}
.guestinfor .left img{width:100%;height:100%;}
.guestinfor .right {flex: 1;}
.guestinfor .right .guestmain{height:100px;padding-top: 23px;font-size:16px;color: #000;line-height: 18px;box-sizing: border-box;margin-bottom: 17px;}
.guestinfor .right .guestmain .title{font-size:18px;font-weight: bold;line-height: 24px;}
.guestinfor .right .guestcon{font-size:16px;line-height:23px;color: #000;}
</style>